import { render } from "./cancelledorderSvg.vue?vue&type=template&id=3268496b"
import script from "./cancelledorderSvg.vue?vue&type=script&lang=js"
export * from "./cancelledorderSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__